import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Plus } from 'lucide-react';
import AdminUsers from '../components/admin/AdminUsers';

// Accounts — login accounts and their granular permissions (docs/modules/
// auth-admin.md §6). Lives in the Settings family next to /settings/roles;
// the route is guarded by RequirePermission('admin:users') in App.js.
// Header mirrors WorkflowListShell: title left, New button on the same row.
const SettingsAccounts = () => {
  const [showCreate, setShowCreate] = useState(false);
  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <Link to="/manage" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700"><ArrowLeft className="w-4 h-4" />Management</Link>
      <div className="mt-2 mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-slate-900">Accounts</h1>
          <p className="text-sm text-slate-500 mt-1">
            Login accounts, roles and per-user permissions.
          </p>
        </div>
        <button
          onClick={() => setShowCreate(true)}
          className="inline-flex items-center justify-center gap-2 px-3 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700"
        >
          <Plus className="w-4 h-4" /> New User
        </button>
      </div>
      <AdminUsers showCreate={showCreate} setShowCreate={setShowCreate} />
    </div>
  );
};

export default SettingsAccounts;
